import departmentsTableTemplate from './view.html';

import { DepartmentsTableController } from './controller';

const DepartmentsTableComponent = {
    template: departmentsTableTemplate,
    controller: DepartmentsTableController,
    controllerAs: '$',
    scope: true,
    bindings: {
        setLoading: '<',
        setDepartmentCount: '<',
        isSelectable: '<',
        isEditable: '<',
        isDisclosed: '<',
        isAnyLoading: '<',
        courseId: '<',
        isReport: '<',
        isReportModal: '<',
        isVuln: '<',
        isVulnModal: '<',
        isRating: '<',
        departmentCheckedCache: '=',
        departmentPartialCache: '=',
        reloading: '<',
        search: '<',
        managerId: '<',
        rebuildLoading: '<',
        setReloading: '=',
        getReportParams: '=',
        graphMode: '<',
        modeData: '<',
        setSearch: '=',
        software: '<',
        trainingOpen: '=',
        isErrorHidden: '<',
    },
};

export {
    DepartmentsTableComponent,
};
